import {client} from "@/httpClient";
import {i18n} from "@/i18n";
import {useMutation} from "@tanstack/react-query";

export const FEEDBACK_KEYS = {
  mSendFeedback: ["/feedback/"],
} as const;

export const useSendFeedbackMutation = () =>
  useMutation({
    meta: {successMessage: i18n.t("feedback:feedback_success")},
    mutationFn: (text: string) => client.post(FEEDBACK_KEYS.mSendFeedback[0], {text}),
    mutationKey: FEEDBACK_KEYS.mSendFeedback,
  });
